import React from 'react';

import CheckBox from 'sharedreact/components/CheckBox';
import ParameterComponent from 'sharedreact/components/ParameterComponent';

type Props = {
  className?: string,
  id: string,
  name: string,
  label: string,
  labelClassName?: string,
  frontLabel?: string,
  labelTooltip?: string,
  value: boolean,
  disabled?: boolean,

  onChangeValue: (name: string, value: boolean, event: React.ChangeEvent<HTMLInputElement>) => void
};

type DefaultProps = Required<Pick<Props, 'frontLabel'>>;

type PropsWithDefaults = Omit<Props, keyof DefaultProps> & DefaultProps;

class CheckBoxField extends React.PureComponent<Props> {
  static defaultProps: DefaultProps = {
    frontLabel: ''
  };

  override render (): React.ReactNode {
    const {
      id,
      className,
      name,
      frontLabel,
      label,
      labelClassName,
      labelTooltip,
      value,
      disabled,
      onChangeValue
    } = (this.props as PropsWithDefaults);
    
    return (
      <ParameterComponent
        className={className}
        label={frontLabel}
        labelClassName={labelClassName}
        labelTooltip={labelTooltip}
      >
        <CheckBox checked={value}
          id={id}
          label={label}
          disabled={disabled}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChangeValue(name, event.target.checked, event)}
        />
      </ParameterComponent>
    );
  }
}

export default CheckBoxField;
